import View from './View';
import Edit from './Edit';
import schema from './schema';
import icon from '@plone/volto/icons/cards.svg';

const CardsBlock = {
  id: 'cards',
  title: 'Cards',
  view: View,
  edit: Edit,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default CardsBlock;